// extracted by mini-css-extract-plugin
export default {"progress":"Prograss_progress__UIk+7","detail":"Prograss_detail__1Xu8U","bar":"Prograss_bar__TdTIF"};